import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: "/",
  redirect: "/login"
},
{
  path: '/login',
  name: 'Login',
  component: () => import('@/views/login/login.vue')
},
{
  path: '/findPassword',
  name: 'FindPassword',
  component: () => import('@/views/login/findPassword.vue')
},
{
  path: '/index',
  name: 'Index',
  component: () => import('@/views/index/index.vue')
},
{
  path: '/detaile',
  name: 'Detaile',
  component: () => import('@/views/detaile/detaile.vue')
},
]

const router = new VueRouter({
  // mode: 'history',
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router